export default __webpack_public_path__ + "static/media/neonmetrics.d85210b7.svg";